'use strict'
const merge = require('webpack-merge')
const devEnv = require('./dev.env')

module.exports = merge(devEnv, {
  NODE_ENV: '"testing"',
  API: '"https://test.cortinasonline.com/api/v1/"',
  MP_TOKEN: 'TEST-dfd0add1-f6f7-4f8c-9bfb-d9538c7d5249',
  FILES_URL: 'http://localhost:3002/uploads/'
})



//////////////////
// WEBPACK FOOTER
// ./config/test.env.js
// module id = WXia
// module chunks = 15